<div class="pricing-container" [class.one-time-notice-visible]="user" [class.donation-mode]="selectedPeriod === 'one_time'">
  <tyt-one-time-offer-notice *ngIf="sendToSettings"></tyt-one-time-offer-notice>
  <div *ngIf="!isEmbedded" class="membership-value-content">
    <!-- <div *ngIf="offerSet.membership_value_prop_subtitle" class="subtitle">
      {{ offerSet.membership_value_prop_subtitle }}
    </div> -->
    <!-- <div class="prop-wrapper">
      <ul class="shrinkable">
        <li class="sentinel"></li>
        <li *ngFor="let valueProps of offerSet.membership_value_props" class="props">{{ valueProps }}</li>
      </ul>
    </div> -->
    <tyt-vertical-carousel *ngIf="offerSet.membership_value_props && offerSet.membership_value_props.length > 0">
      <tyt-vertical-carousel-item *ngFor="let valueProps of offerSet.membership_value_props">{{ valueProps }}</tyt-vertical-carousel-item>
    </tyt-vertical-carousel>
  </div>
  <ng-container *ngIf="offerSet.is_pay_what_you_want">

    <div class="period-selector-container" *ngIf="availablePeriods?.length > 1">
      <div class="period-selector">
        <a
          [routerLink]="[]" [queryParams]="{ period: availablePeriod[0] }"
          [class.selected-period]="availablePeriod[0] === selectedPeriod"
          *ngFor="let availablePeriod of availablePeriods">
          <span>{{availablePeriod[1]}}</span>
        </a>
      </div>
    </div>
  </ng-container>

  <div class="price-box-container">
    <!-- <div class="prompt" *ngIf="!isHtmlEmpty(offerSet.pricing_prompt)" [innerHTML]="offerSet.pricing_prompt | trustHtml"></div> -->
    <!-- <div class="summary" *ngIf="!isHtmlEmpty(offerSet.pricing_prompt_summary)" [innerHTML]="offerSet.pricing_prompt_summary | trustHtml"></div> -->
    <ng-container *ngIf="offerSet.is_pay_what_you_want">
      <div class="inline-pricing-options">


        <div class="preview-indicator" *ngIf="previewing">
          <div>Preview</div>
        </div>

        <div class="header" *ngIf="!isHtmlEmpty(offerSet.pricing_prompt)" [innerHTML]="offerSet.pricing_prompt | trustHtml"></div>
        <div class="pricing" *ngIf="!isHtmlEmpty(offerSet.pricing_prompt_summary)" [innerHTML]="offerSet.pricing_prompt_summary | trustHtml"></div>

        <tyt-offer-tier
          *ngIf="hasTier1Offers && (offerSet.tier1_label || offerSet.tier1_summary)"
          [label]="offerTierData(1, 'label')"
          [summary]="offerTierData(1, 'summary')"
          [tooltip]="offerTierData(1, 'tooltip')"
        ></tyt-offer-tier>

        <ng-container *ngFor="let offer of offersBySelectedPeriod">
          <tyt-offer-tier
            *ngIf="offer === firstTier2Offer && (offerSet.tier2_label || offerSet.tier2_summary)"
            [label]="offerTierData(2, 'label')"
            [summary]="offerTierData(2, 'summary')"
            [tooltip]="offerTierData(2, 'tooltip')"
            ></tyt-offer-tier>
          <a
            class="offer-link"
            [target]="inSettings ? '_self' : '_parent'"
            *ngIf="!offer.subsidized || offer.sponsorship_available || !hideSponsoredOffersWhenUnavailable"
            [routerLink]="getOfferRouterLink(offer)"
            [class.unavailable]="offer.subsidized && !offer.sponsorship_available"
            [queryParams]="getOfferQueryParams(offer)"
            (click)="offerSelected(offer)">
            <tyt-offer-inline-pricing
              [offer]="offer"
              [isOther]="false"
              [subsidizedPrice]="subsidizedPrice"
              [class.unavailable]="offer.subsidized && !offer.sponsorship_available"
              ></tyt-offer-inline-pricing>
          </a>
        </ng-container>

        <a class="offer-link" href="javascript:;" (click)="showOther = true" *ngIf="allowCustomPricing && offerSet.enable_name_your_own_price">
          <tyt-offer-inline-pricing
            [isOther]="true"
            ></tyt-offer-inline-pricing>
        </a>

        <div class="single-offer-hint" *ngIf="!allowCustomPricing && offersBySelectedPeriod.length == 1">
          <em>
            <span class="mobile">
              Tap
            </span>
            <span class="desktop">
              Click
            </span>
            the offer above to continue.
          </em>
        </div>
      </div>

      <!-- <div class="pricing-options">
        <a
          *ngFor="let offer of offersBySelectedPeriod"
          routerLink="{{getOfferRouterLink(offer)}}"
          [queryParams]="getOfferQueryParams(offer)"
          class="pwyw-option">
          <ng-container *ngIf="offer.price % 100 === 0"
            >{{ offer.price / 100 | currency:'USD' : digitInfo : '1.0-0' }}{{ frequencySuffixForPeriod(offer.period) }}</ng-container
            ><ng-container *ngIf="offer.price % 100 !== 0"
            >{{ offer.price / 100 | currency:'USD' : digitInfo : '1.2-2' }}{{ frequencySuffixForPeriod(offer.period) }}</ng-container
            >

        </a>
        <a
          (click)="showOther = true"
          class="pwyw-option other">
          Other
        </a>
      </div> -->

      <div class="other-form-container">
        <form (submit)="submitOtherAmount()" *ngIf="showOther" class="other-form">
          <div class="other-price-selector">
            <span class="prefix">
              $
            </span>
            <input
              type="number"
              [(ngModel)]="otherAmount"
              #otherAmountInput
              name="otherAmount"
              [min]="minCustomPrice"
              [max]="maxCustomPrice"
              />
            <span class="suffix">
              {{frequencySuffixForPeriod(selectedPeriod)}}
            </span>
            <button
              class="join-button"
              [disabled]="otherAmount < minCustomPrice || otherAmount > maxCustomPrice || !isCustomPriceValid"
              >{{ joinButtonText }}</button>
          </div>
          <div class="other-price-hint">
            <span class="message">
              <ng-container *ngIf="otherAmount !== null">
                <ng-container *ngIf="!isCustomPriceValid">
                  Please enter a valid amount in US dollars
                </ng-container>
                <ng-container *ngIf="isCustomPriceValid">
                  <ng-container *ngIf="otherAmount < minCustomPrice && selectedPeriod != 'one_time'">
                    To cover our processing costs, we can’t accept contributions less than {{
                      minCustomPrice | currency: 'USD'
                    }}{{frequencySuffixForPeriod(selectedPeriod)}}
                  </ng-container>
                  <ng-container *ngIf="otherAmount > maxCustomPrice && selectedPeriod != 'one_time'">
                    Choose a price below {{
                      maxCustomPrice | currency: 'USD'
                    }}{{frequencySuffixForPeriod(selectedPeriod)}}
                  </ng-container>
                  <ng-container *ngIf="selectedPeriod === 'one_time'">
                    <span
                      [ngClass]="{
                        'belowMin': oneTimeMessageType === 'below-min',
                        'belowEntitlement': oneTimeMessageType === 'below-entitlement',
                        'entitled': oneTimeMessageType === 'entitled'
                      }">
                      {{ oneTimeCustomMessage }}
                    </span>
                  </ng-container>
                </ng-container>
              </ng-container>
            </span>
          </div>
        </form>
      </div>

      <ng-container *ngIf="actBlueLink && selectedPeriod === 'one_time'">
        <div class="actblue">
          <div>Or donate with:</div>
          <a [href]="actBlueLink" target="_blank">
          </a>
        </div>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="!offerSet.is_pay_what_you_want">
      <div class="prompt" [class.prompt-embedded]="isEmbedded" *ngIf="!isHtmlEmpty(offerSet.pricing_prompt) && isEmbedded" [innerHTML]="offerSet.pricing_prompt | trustHtml"></div>
      <div class="summary" [class.summary-embedded]="isEmbedded" *ngIf="!isHtmlEmpty(offerSet.pricing_prompt_summary) && isEmbedded" [innerHTML]="offerSet.pricing_prompt_summary | trustHtml"></div>
      <div class="pricing-options fixed-price">
        <ng-container *ngFor="let offer of offerSet.offers">
          <tyt-fixed-price-offer
            *ngIf="offer.above_the_fold && offer.membership_product"
            [offer]="offer"
            [offerSet]="offerSet"
            ></tyt-fixed-price-offer>
        </ng-container>
      </div>
      <div *ngIf="hasBelowTheFold" class="below-fold"  [class.hidden]="showMoreOffers" (click)="toggleMoreOffers()">
        <div><span class="highlight">OR</span> SEE MORE OFFERS</div>
        <div><img src="/assets/offers/arrow-down.svg"></div>
      </div>
      <div class="pricing-options" [class.hidden]="!showMoreOffers">
        <ng-container *ngFor="let offer of offerSet.offers">
          <tyt-fixed-price-offer
            *ngIf="!offer.above_the_fold && offer.membership_product"
            [offer]="offer"
            [offerSet]="offerSet"
            ></tyt-fixed-price-offer>
        </ng-container>
      </div>
      <div *ngIf="hasBelowTheFold" class="below-fold"  [class.hidden]="!showMoreOffers" (click)="toggleMoreOffers()">
        <div><img src="/assets/offers/arrow-up.svg"></div>
        <div>CLOSE OTHER OFFERS</div>
      </div>
    </ng-container>
    <div class="company-values" *ngIf="offerSet.company_value_props_title || offerSet.company_value_props && offerSet.company_value_props.length > 0 || offerSet.is_pay_what_you_want">
      <div class="company-values-content">
        <div class="sizer">
          <div class="ql-editor title" *ngIf="offerSet.company_value_props_title" [innerHTML]="offerSet.company_value_props_title | trustHtml"></div>
          <div class="prop" *ngFor="let props of offerSet.company_value_props">{{ props.title }}</div>
        </div>
      </div>
    </div>
    <div *ngIf="showNoThanks" class="embedded-no-thanks">
      <a href="javascript:;" (click)="noThanksClicked()">No Thanks</a>
    </div>
  </div>
</div>
